import PageView from './components/Pagelayout';
import { load } from 'hydrate/client/load';
import { createProviders } from 'hydrate/client/createProviders';

function hydrateClient() {
  void load('PageView', PageView, {
    createProviders,
    metadata: { translations: window.translations }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateClient);
} else {
  hydrateClient();
}
